import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { SelectorButton } from '../selectorButton/index.js';
import { jsx } from '@emotion/react';

var _excluded = ["checked", "children", "disabled", "icon", "onClick", "size", "type"];
var RadioButton = _ref => {
  var {
    checked,
    children = null,
    disabled = false,
    icon = null,
    onClick = () => undefined,
    size = 'small',
    type = 'primary'
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx(SelectorButton, _extends({
    checked: checked,
    disabled: disabled,
    icon: icon,
    onClick: onClick,
    selector: "radio",
    size: size,
    type: type // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), children);
};

export { RadioButton, RadioButton as default };
